import { Box, Checkbox, FormControl, FormControlLabel, FormGroup } from '@mui/material';
import { setTransportConditionCheckedType } from 'app/actions/map';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
const MapTransportConditionFilterList = () => {
    const dispatch = useDispatch();
    const checkedType = useSelector((state) => state.map.transportConditionFilterCheckedType);
    const handleChange = (event) => dispatch(setTransportConditionCheckedType(event.target.name));
    return (React.createElement(Box, { component: 'ul', sx: (theme) => ({
            display: 'flex',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '10px',
            width: '100%',
            listStyle: 'none',
            position: 'relative',
            padding: '0 12px',
            margin: theme.spacing(0),
            '.MuiFormLabel-root': {
                marginBottom: '6px',
                fontSize: '12px',
                '&.Mui-focused': {
                    color: 'text.secondary',
                },
            },
            '.MuiFormControlLabel-root': {
                userSelect: 'none',
                margin: theme.spacing(0),
                padding: theme.spacing(0),
                '.MuiCheckbox-root': {
                    padding: theme.spacing(0),
                    marginRight: '4px',
                },
            },
            '.MuiFormControlLabel-label': {
                whiteSpace: 'nowrap',
            },
        }) },
        React.createElement(FormControl, { component: 'fieldset', variant: 'standard' },
            React.createElement(FormGroup, null,
                React.createElement(FormControlLabel, { label: '\u0412\u0441\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F', control: React.createElement(Checkbox, { size: 'small', name: 'all', disableRipple: true, onChange: handleChange, checked: checkedType === 'all' }) }))),
        React.createElement(FormControl, { component: 'fieldset', variant: 'standard' },
            React.createElement(FormGroup, null,
                React.createElement(FormControlLabel, { label: '\u0424\u0438\u043B\u044C\u0442\u0440\u044B', control: React.createElement(Checkbox, { size: 'small', name: 'filter', disableRipple: true, onChange: handleChange, checked: checkedType === 'filter' }) })))));
};
export default MapTransportConditionFilterList;
